var chunkToChildrenMap = {
	"1887": [
		5608
	],
	"2253": [
		1887,
		1631,
		6689
	],
	"3150": [
		2253
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));